enum select {
    'add_option' = 'Add option',
    'add_option_here' = 'Add option here...',
    'items_selected' = '{count} items selected',
    'no_selected' = 'Nothing selected...',
    'search_clear' = 'Clear search',
    'search_here' = 'Search here...',
    'search_here_or_add_option_here' = 'Search here or add option here...',
    'search_no_found' = 'No results found...',
    'select_all' = 'Select all',
}

export default select;
